<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
    beforeCreate() {
      document.querySelector('body').setAttribute('style', 'margin:0px')
    }
  }

</script>

<style>
  /* html{
  margin: 0px;
}
body{
  background-color: #0084cf;
} */
  /* 网页全部变灰色 */
  /* html{
filter: grayscale(100%);
-moz-filter: grayscale(100%);
-o-filter: grayscale(100%);
-webkit-filter: grayscale(1);
} */
  #app {
    min-width: 1250px;
  }

  .margin-middle {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }

  .hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tab-box>div {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue